import { render, staticRenderFns } from "./SiderForm.vue?vue&type=template&id=63b2083b&scoped=true&"
import script from "./SiderForm.vue?vue&type=script&lang=js&"
export * from "./SiderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b2083b",
  null
  
)

export default component.exports